export default {
    import: "导出文件",
    peopleBook: "预约人数",
    booked: "预约次数",
    clickHere: "点击这里查看详情",
    updated: "更新预约",
    btn: {
        creat: "创建",
        creatFund: "创建基金",
        pagination: "每页显示数量",
    },

    tapList: {
        total: "全部",
        active: "启用中",
        inactive: "未启用",
        pending: "待审核",
        reject: "已拒绝",
        draft: "草稿",
    },
    tapManage: {
        all: "所有候选人",
        waiting: "等待面试",
        rejectbook: "已拒绝面试预约",
        pending: "等待状态更新",
        passed: "面试通过",
        notPass: "面试未通过",
        missed: "缺席面试",
    },
    tapManage_consult: {
        all: "全部",
        waiting: "等待咨询",
        rejectbook: "已拒绝咨询",
        pending: "等待状态更新",
        passed: "咨询完成",
        notPass: "咨询未通过",
        missed: "未参加咨询",
    },

    header: {
        updatedAt: "最后更新日期",
        jopPo: "详情",
        jopPoFund: "基金详情",
        appAmount: "申请人数",
        status: "状态",
    },

    amount: {
        all: "全部",
        appAll: "申请人总数",
        notViewedResume: "未查看简历",

        booking: "预约",
        applyJob: "职位申请",
    }
};